export default __webpack_public_path__ + "static/media/ic-ops.95c8741c.svg";